// extracted by mini-css-extract-plugin
export var update_excerpt = "Post-module--update_excerpt--6-7Fi";
export var update_image = "Post-module--update_image--xJSae";
export var update_preview = "Post-module--update_preview--3AHw9";